"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : new P(function (resolve) {
                resolve(result.value);
            }).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const constants_1 = require("../constants");
const LoadingSpinner_1 = require("../shared/LoadingSpinner");
const react_bootstrap_1 = require("react-bootstrap");
const utils_1 = require("../utils");
const api_1 = require("../api");
class BecomeAmbassador extends React.Component {
    constructor(props) {
        super(props);
        this.fullName = '';
        this.fullNameError = false;
        this.occupation = '';
        this.occupationError = false;
        this.occupationLicense = '';
        this.occupationLicenseError = false;
        this.address = '';
        this.addressError = false;
        this.city = '';
        this.cityError = false;
        this.states = '';
        this.statesError = false;
        this.zipCode = '';
        this.zipCodeError = false;
        this.state = {
            status: constants_1.ProgressState.Loading,
            showSuccess: false
        };
        this.handleSave = this.handleSave.bind(this);
    }
    validateData() {
        if (this.fullName === '' || this.fullName.length > 150) {
            this.fullNameError = true;
            this.forceUpdate();
            return false;
        } else {
            this.fullNameError = false;
            this.forceUpdate();
        }
        if (this.occupation === '' || this.occupation.length > 150) {
            this.occupationError = true;
            this.forceUpdate();
            return false;
        } else {
            this.occupationError = false;
            this.forceUpdate();
        }
        if (this.occupationLicense === '' || this.occupationLicense.length > 150) {
            this.occupationLicenseError = true;
            this.forceUpdate();
            return false;
        } else {
            this.occupationLicenseError = false;
            this.forceUpdate();
        }
        if (this.address === '' || this.address.length > 150) {
            this.addressError = true;
            this.forceUpdate();
            return false;
        } else {
            this.addressError = false;
            this.forceUpdate();
        }
        if (this.city === '' || this.city.length > 150) {
            this.cityError = true;
            this.forceUpdate();
            return false;
        } else {
            this.cityError = false;
            this.forceUpdate();
        }
        if (this.states === '' || this.states.length > 150) {
            this.statesError = true;
            this.forceUpdate();
            return false;
        } else {
            this.statesError = false;
            this.forceUpdate();
        }
        if (this.zipCode === '' || this.zipCode.length > 150) {
            this.zipCodeError = true;
            this.forceUpdate();
            return false;
        } else {
            this.zipCodeError = false;
            this.forceUpdate();
        }
        return true;
    }
    handleSave() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.validateData()) {
                api_1.doPost(api_1.API.v1.BUSINESSES.REQUEST_TO_BECOME_AMBASSADOR, {
                    fullName: this.fullName,
                    occupation: this.occupation,
                    occupationLicense: this.occupationLicense,
                    address: this.address,
                    city: this.city,
                    state: this.states,
                    zipCode: this.zipCode
                }).then(data => {
                    this.setState({
                        showSuccess: true
                    });
                }).catch(error => {
                    api_1.handleError(error);
                });
            }
        });
    }
    render() {
        let content;
        if (this.state.status === constants_1.ProgressState.Success) {
            content = this.renderData();
        } else if (this.state.status === constants_1.ProgressState.Failed) {
            content = React.createElement("h4", null, " Somethings went Wrong ");
        } else {
            content = React.createElement("div", { className: "text-center mt-2" }, React.createElement(LoadingSpinner_1.default, null));
        }
        return React.createElement("div", { className: "redeem-coupon" }, content);
    }
    componentDidMount() {
        this.setState({
            status: constants_1.ProgressState.Success
        });
    }
    renderData() {
        return React.createElement("div", { className: "panel mt-2" }, React.createElement("div", { className: `` }, React.createElement("div", { className: `zc_temp_header` }, "LoyalReach"), React.createElement("div", { className: `flex-center zc_cont` }, React.createElement(react_bootstrap_1.Col, { xs: 12, lg: 4, md: 4, className: `center-all mt-15` }, React.createElement("div", { className: `amb_top` }, "Thank you for choosing to become an ambassador of your community!"), React.createElement("div", { className: `amb_top` }, "What does this role entails?", React.createElement("br", null), "On the rare occasion when we receive an alert within your community which we could not verify its legitimacy, we will send the ambassadors within that community a message and ask if anyone could validate its legitimacy before we broadcast the message to everyone.  For example, if we received an alert for fire from anyone in your community, we will send you message asking if you could see fire or smoke around your area?  If you validate it and answer \u201CYes\u201D, the message will be broadcasted to all members in the community.  If you cannot validate it, you can answer with \u201CNo\u201D or ignore the message.  We will only broadcast the message if we receive at least 1 \u201CYes\u201D from an ambassador."), React.createElement("div", { className: `amb_top` }, "Who can qualify for this role?", React.createElement("br", null), "Any public servant (i.e. Police man, Firefighter, Nurse, Doctor, etc.) can become an ambassador."), React.createElement("div", { className: `amb_top` }, "What we need from you?", React.createElement("br", null), "Please provide the following information and click on submit."), this.state.showSuccess && React.createElement("div", { className: `amb_top success_message_amb center-all` }, "Thank You for you support"), !this.state.showSuccess && React.createElement("div", null, React.createElement(react_bootstrap_1.FormGroup, { controlId: "fullName", className: `mt-15` }, React.createElement(react_bootstrap_1.ControlLabel, null, "Full Name"), React.createElement(react_bootstrap_1.FormControl, { name: "fullName", type: "text", placeholder: "Enter Your full name", onChange: event => utils_1.FormUtils.dataChanged(event, this) }), this.fullNameError && React.createElement("p", { className: 'become_amb_error' }, " required field ")), React.createElement(react_bootstrap_1.FormGroup, { controlId: "occupation", className: `mt-15` }, React.createElement(react_bootstrap_1.ControlLabel, null, "Occupation"), React.createElement(react_bootstrap_1.FormControl, { name: "occupation", type: "text", placeholder: "Enter Your occupation", onChange: event => utils_1.FormUtils.dataChanged(event, this) }), this.occupationError && React.createElement("p", { className: 'become_amb_error' }, " required field ")), React.createElement(react_bootstrap_1.FormGroup, { controlId: "occupationLicense", className: `mt-15` }, React.createElement(react_bootstrap_1.ControlLabel, null, "Occupation License"), React.createElement(react_bootstrap_1.FormControl, { name: "occupationLicense", type: "text", placeholder: "Enter Your Occupation License", onChange: event => utils_1.FormUtils.dataChanged(event, this) }), this.occupationLicenseError && React.createElement("p", { className: 'become_amb_error' }, " required field ")), React.createElement(react_bootstrap_1.FormGroup, { controlId: "address", className: `mt-15` }, React.createElement(react_bootstrap_1.ControlLabel, null, "Address"), React.createElement(react_bootstrap_1.FormControl, { name: "address", type: "text", placeholder: "Enter Your address", onChange: event => utils_1.FormUtils.dataChanged(event, this) }), this.addressError && React.createElement("p", { className: 'become_amb_error' }, " required field ")), React.createElement(react_bootstrap_1.FormGroup, { controlId: "city", className: `mt-15` }, React.createElement(react_bootstrap_1.ControlLabel, null, "City"), React.createElement(react_bootstrap_1.FormControl, { name: "city", type: "text", placeholder: "Enter Your City", onChange: event => utils_1.FormUtils.dataChanged(event, this) }), this.cityError && React.createElement("p", { className: 'become_amb_error' }, " required field ")), React.createElement(react_bootstrap_1.FormGroup, { controlId: "states", className: `mt-15` }, React.createElement(react_bootstrap_1.ControlLabel, null, "State"), React.createElement(react_bootstrap_1.FormControl, { name: "states", type: "text", placeholder: "Enter Your State", onChange: event => utils_1.FormUtils.dataChanged(event, this) }), this.statesError && React.createElement("p", { className: 'become_amb_error' }, " required field ")), React.createElement(react_bootstrap_1.FormGroup, { controlId: "zipCode", className: `mt-15` }, React.createElement(react_bootstrap_1.ControlLabel, null, "Zip Code"), React.createElement(react_bootstrap_1.FormControl, { name: "zipCode", type: "text", placeholder: "Enter Your Zip Code", onChange: event => utils_1.FormUtils.dataChanged(event, this) }), this.zipCodeError && React.createElement("p", { className: 'become_amb_error' }, " required field ")), React.createElement(react_bootstrap_1.FormGroup, { controlId: "submit", className: `mt-15 mb-30` }, React.createElement(react_bootstrap_1.Button, { className: "btn-success become_amb_btn", bsStyle: "default", title: "SUBMIT", onClick: () => this.handleSave() }, "SUBMIT")))))));
    }
}
exports.default = BecomeAmbassador;


//////////////////
// WEBPACK FOOTER
// ./client/src/layout/BecomeAmbassador.tsx
// module id = 1359
// module chunks = 1 2